import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
import actions from './actions'
import mutations from './mutations'
import { setStore, getStore } from '@/until/utils'

Vue.use(Vuex);
const state = {
    cart_count: '' || JSON.parse(getStore('cart_count')) //购物车数量

}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters

})


// WEBPACK FOOTER //
// ./src/store/index.js